<button
  type="button"
  class="flex items-center justify-center border-solid cursor-pointer"
  style="
    gap: var(--filterchip-gap, var(--spacing-xs));
    height: var(--filterchip-height, 33px);
    padding: var(--filterchip-padding-y, var(--spacing-sm)) var(--filterchip-padding-x, var(--spacing-md));
    border-radius: var(--filterchip-border-radius, var(--radius-full));
  "
  [style.background-color]="backgroundColor()"
  [style.border-color]="borderColor()"
  [style.border-width]="borderWidth()"
  [disabled]="disabled()"
  (click)="onClick()"
>
  @if (hasIcon()) {
    <app-dynamic
      componentName="SvgIcon"
      [props]="{ name: config().icon, size: '16', color: contentColor() }"
    />
  }
  @if (hasLabel()) {
    <app-dynamic
      componentName="DynamicText"
      [props]="{ config: textConfig() }"
    />
  }
</button>
